/**
 * Parse SSE data line and invoke callback
 */
const parseSSEData = (line, onChunk) => {
  if (!line.startsWith('data: ')) return;

  const dataStr = line.slice(6).trim();

  if (dataStr === '[DONE]' || !dataStr) return;

  try {
    const data = JSON.parse(dataStr);
    onChunk?.(data);
  } catch {
    // Fallback to plain text if JSON parsing fails
    onChunk?.({ text: dataStr });
  }
};

/**
 * Process buffered stream data and extract complete lines
 */
const processStreamBuffer = (buffer, onChunk) => {
  const lines = buffer.split('\n');
  const remainingBuffer = lines.pop() || '';

  lines.forEach((line) => parseSSEData(line, onChunk));

  return remainingBuffer;
};

/**
 * Read and process stream chunks from a ReadableStream reader
 * @param {ReadableStreamDefaultReader} reader - The stream reader
 * @param {TextDecoder} decoder - Text decoder instance
 * @param {Function} onChunk - Callback for each data chunk
 * @param {Function} onComplete - Callback when stream completes
 * @param {Function} onError - Callback for errors
 */
export const processStream = async (reader, decoder, onChunk, onComplete, onError) => {
  let buffer = '';

  try {
    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        onComplete?.();
        break;
      }

      buffer += decoder.decode(value, { stream: true });
      buffer = processStreamBuffer(buffer, onChunk);
    }
  } catch (error) {
    console.error('Stream reading error:', error);
    onError?.(error);
  }
};
